import ProductApi from "../../../../services/api/productApi.js";

const ProductApiService = new ProductApi();

export default {
  props: {
    productId: {
      type: String,
    },
    brandId: {
      type: String,
    },
  },
  data() {
    return {
      products: [],
    };
  },

  methods: {
    getSimilarProducts,
  },

  mounted() {
    this.getSimilarProducts();
  },
};

function getSimilarProducts() {
  const _self = this,
    request = {
      product_id: _self.productId,
      brand_id: _self.brandId,
      product_number: this.$utils.constants.SIMILAR_PRODUCTS_LIMIT,
    };

  ProductApiService.getSimilarProducts(request)
    .then((response) => {
      const products = response.data;

      products.forEach(function (product) {
        product.brand = {
          id: product.brand_id,
          company_name: product.brand_name,
          minimum_order_value: product.brand_minimum_order_value,
        };

        product.image = product.images[0];

        product.category = {
          name: product.category_name,
        };
      });

      _self.products = products;
    })
    .catch((error) => {
      if (error.response) {
        _self.$swal("Attention", error.response.data.error_message);
      } else {
        _self.$logger.notify(new Error(error));
      }
    });
}
